export default function isFreeSeller(seller) {
  return seller?.plan?.handle === 'free';
}
